<template>
	<div id='addCashierdiaryDialog'>
		<el-dialog
			:visible.sync="isShow"
			:show-close='true'  
			width='872px'
			top='60px'
			:close-on-click-modal="false"
			:title="cashierdiaryDialogTitle"
			
		>	
			<div v-loading='addCashierdiaryDialogLoading' element-loading-text='拼命加载中...'>
				<div class='add_title'>
					<el-row class='addHeader'>
						<el-col  :span="14" style='line-height: 40px;'>
							<span style='margin-right: 10px;font-weight: 600;color: #333'>账户</span>
							 <el-select
					            placeholder="请选择" size="small" 
					            v-model="form.fkJournalAccountId" :clearable="false" filterable
					            @change='handleSelectChange'
					          >
					            <el-option v-for="(item,index) in userAccount" :key="index" :label="item.name" :value="item.id"></el-option>
					          </el-select>
						</el-col>
						<el-col  :span="7" style='text-align:right;padding-right: 5px;'>
							<el-checkbox v-model='fastChange' class='fast_change' :disabled='fastChange_dis'
							>启用快速添加面板</el-checkbox>
							<el-popover  trigger="click" >
								<img src="/static/img/addToolTip.png" alt="">
								<i class='el-icon-warning-outline' style='color: #F5A623;line-height: 40px;margin-left: 8px;font-size: 16px'  slot='reference'></i>
							</el-popover>
						</el-col>
						<el-col  :span="3" style='text-align:right;'>
							<!-- <el-button type='text' icon="el-icon-circle-plus-outline" @click='addShow'>配置表单</el-button> -->
							<span class='setForm' @click='addShow'><i class="el-icon-edit" style="margin-right: 5px;font-size: 16px;"></i>配置表单</span>
						</el-col>
					</el-row>
				</div>
				
				<div class='addContent'>
					<div class='addContent_container'>
						<el-form :model='form' label-width='125px' label-position='left' :rules="rules" ref='modalData' v-if='modalR' 
									>
							<el-form-item label="日期" prop='date'>
								<el-row>
									<el-col :span='22'>
										<el-date-picker
										  @change='handleDateChange'
										  style='width: 230px;'
									      v-model="form.date"
									      @keyup.enter.native="keyUpEnterDown('date')"
									      @blur="keyUpEnterDown('date')"
									      type="date"
									      size='mini'
									      ref='dateDom'
									      placeholder="开始时间">
									    </el-date-picker>
									</el-col>
									<el-col :span='2' style='text-align:right'>
										<el-popover  trigger="hover" width="60">
									     	<span class='edit' @click='handleEditItems("1")'>编辑</span>
									    	<img src="/static/icon/edit_dot.svg" alt="" slot='reference'>
									     </el-popover>
									</el-col>
								</el-row> 
							</el-form-item>
							<el-form-item label='摘要' prop='summary'> 
								<el-row>
									<el-col :span='22'>
										<el-input  @keyup.enter.native="keyUpEnterDown('summary')" ref='summaryDom' v-model='form.summary' size='mini' placeholder='请输入摘要'  style='width: 100%;' @focus='hanleInputFocus' @blur="isInputBlur('summary')"></el-input>
									</el-col>
									<el-col :span='2' style='text-align:right'>
										<el-popover  trigger="hover" width="60">
									     	<span class='edit' @click='handleEditItems("2")'>编辑</span>
									    	<img src="/static/icon/edit_dot.svg" alt="" slot='reference'>
									     </el-popover>
									</el-col>
								</el-row>
							</el-form-item>
							<el-form-item label='收入' prop='debitMoney'> 
								<el-row>
									<el-col :span='22'>
										<el-input v-model='form.debitMoney' size='mini' placeholder='请输入收入'  style='width: 230px;' @blur="isInputBlur('debitMoney')" @focus='hanleInputFocus' @input='clearOther("1")' @keyup.enter.native="keyUpEnterDown('debitMoney')" ref='debitMoneyDom'></el-input>
									</el-col>
									<el-col :span='2' style='text-align:right'>
										<el-popover  trigger="hover" width="60">
									     	<span class='edit' @click='handleEditItems("3")'>编辑</span>
									    	<img src="/static/icon/edit_dot.svg" alt="" slot='reference'>
									     </el-popover>
									</el-col>
								</el-row>
							</el-form-item>
							<el-form-item label='支出' prop='creditorMoney'> 
								<el-row>
									<el-col :span='22'>
										<el-input @keyup.enter.native="keyUpEnterDown('creditorMoney')" ref='creditorMoneyDom' v-model='form.creditorMoney' size='mini' placeholder='请输入收入'  style='width: 230px;' @blur="isInputBlur('creditorMoney')" @focus='hanleInputFocus' @input='clearOther("2")' ></el-input>
									</el-col>
									<el-col :span='2' style='text-align:right'>
										<el-popover  trigger="hover" width="60">
									     	<span class='edit' @click='handleEditItems("4")'>编辑</span>
									    	<img src="/static/icon/edit_dot.svg" alt="" slot='reference'>
									     </el-popover>
									</el-col>
								</el-row>
							</el-form-item>

							<!-- 动态渲染 -->
							<draggable  v-model="dragList"
								@start='handleStart'
								@end='handleEnd'
							>
								 <transition-group name="list" tag="p">
									<el-form-item v-for='(item,index) in dragList' :key='item.id' :label='item.columnName' 
										:prop='item.isStuff?item.verification:""'
									> 
										
										<el-row>
											<!-- 文本输入框 -->
											<el-col :span='21'  v-if='item.customType==="1"'>
												<el-input v-model='item.value' size='mini' placeholder='请输入文本'  style='width: 100%;' @focus='hanleInputFocus' @blur="isInputBlur('text')" @keyup.enter.native="keyUpEnterDown(index,item)" :ref='item.enterTime'></el-input>
											</el-col>

											<!-- 日期 -->
											<el-col :span='21'  v-if='item.customType==="2"'>
												<el-date-picker
												  style='width: 230px;'
											      v-model="item.value"
											      @change='handleDateChange'
											      type="date"
											      value-format="yyyy-MM-dd"
											      size='mini'
											      :ref='item.enterTime'
											      @blur="keyUpEnterDown(index,item)"
											      placeholder="开始时间">
											    </el-date-picker>
											</el-col>

											<!-- 数值 -->
											<el-col :span='21'  v-if='item.customType==="3"'>
												<el-input v-model='item.value' size='mini' placeholder='请输入数值'  style='width: 230px;' :disabled='item.valueType===1'
												@focus='hanleInputFocus' @blur="isInputBlur('text')"
												 @keyup.enter.native="keyUpEnterDown(index,item)" :ref='item.enterTime'
												>{{calculation(item)}}</el-input>
												<span style="margin-left:20px;">{{item.unit}}</span>
											</el-col>

											<!-- 单选下拉框 -->
											<el-col :span='21' v-if='item.customType==="4"&&item.isChoice===0'>
												<el-select v-model="item.value" placeholder="请选择" style='width: 230px;' size='mini'  @change='handleDateChange' clearable filterable
												 @blur="keyUpEnterDown(index,item)" :ref='item.enterTime'>
													<span v-for="i in item.optionList" style="display: block;width: 100%;position: relative;">
														 <span class='dotColor' :style="{ background: i.color}"></span>
														 <el-option
													      :key="i.id"
													      style="display: inline-block;width: 100%;padding-left: 30px;font-size: 12px;"
													      :label="i.optionName"
													      :value="i.id">
													    </el-option>
													</span>
												</el-select>
											</el-col>
											<!-- 多选下拉框 -->
											<el-col :span='21' v-if='item.customType==="4"&&item.isChoice===1'>
												<el-select v-model="item.optionListValue" placeholder="请选择" style='width: 230px;' size='mini' multiple  @change='handleDateChange' clearable filterable
												@blur="keyUpEnterDown(index,item)" :ref='item.enterTime'>
													<span v-for="i in item.optionList" style="display: block;width: 100%;position: relative;">
														 <span class='dotColor' :style="{ background: i.color}"></span>
														 <el-option
													      :key="i.id"
													      style="display: inline-block;width: 100%;padding-left: 30px;font-size: 12px;"
													      :label="i.optionName"
													      :value="i.id">
													    </el-option>
													</span>
												</el-select>
											</el-col>
											<!-- 图片上传  class='picUpload'-->
											<el-col :span='21' v-if='item.customType==="5"' >
												<div>
													<el-upload
													  drag
												       class='picUpload'
													  :action="uploadUrl"
													  list-type="picture-card"
													  :on-success="(res, file, fileList)=>{ return handleUploadSuccess(res, file, fileList,item) }"
													  :on-error="errorUpload"
													  :file-list="item.imgList"
													  :before-upload="beforeUpload"
													  :on-preview="handlePictureCardPreview"
													  :on-remove="(file)=>{return handleRemove(file,item)}">
													  <i class="el-icon-plus"></i>
													</el-upload>
												</div>
											</el-col>
											<!-- 通用 -->
											<el-col :span='3' style='text-align:right'>
												<el-popover  trigger="hover"  width="60">
											     	<span class='edit' @click='handleEditItem("modify",item,"common")'>编辑</span>
											     	<span class='cancel' @click='handleEditItem("disable",item,"1")'>禁用</span>
									     			<span class='delete' @click='handleEditItem("delete",item,"nor")'>删除</span>
											    	<img src="/static/icon/edit_dot.svg" alt="" slot='reference'>
											     </el-popover>
											     <img src="/static/icon/drag_mark.svg" alt="" style="margin-left:5px;" class='move_able'>
											</el-col>
										</el-row>

										
									</el-form-item>
								</transition-group>
							</draggable>
							<!-- 动态渲染结束 -->
							<div class='disabled_item' v-show='disableList.length!==0'>
								<span class='disable_on'>已禁用</span>
								<div class='disable_items'>
									<div class='item' v-for='item in disableList' :key='item.id'>
										<span>{{item.columnName}}</span>
										 <el-popover  trigger="click" width="60">
									     	<span class='edit' @click='handleEditItem("modify",item,"common")'>编辑</span>
									     	<span class='cancel' @click='handleEditItem("disable",item,"2")'>取消禁用</span>
									     	<span class='delete' @click='handleEditItem("delete",item,"dis")'>删除</span>
									    	<i class='el-icon-more' slot='reference'></i>
									     </el-popover>
									</div>
								</div>
							</div>
						</el-form>
					</div>
				</div>
				
				<div class='footer'>
					<div class='saveNext_container'>
						<el-checkbox v-model='saveNext' class='saveNext'>保存后继续创建下一条</el-checkbox>
					</div>
					<el-button  size='small' class='cancel_btn' @click='isShow=false'>取消</el-button>
					<el-button  size='small' class='minButton' style='width: 122px;' @click='handleSaveRow'>保存</el-button>
					<div class='nextOrBack'>
						<el-button type='text' class='back' @click='handleClickJump("1")' :disabled='!nowSaveId'>上一张</el-button>
						<el-button type='text' class='back' @click='handleClickJump("2")' :disabled='!nowSaveId'>下一张</el-button>
					</div>
				</div> 
			</div>
		
	    </el-dialog>
	    <transition name='active_fade'>
	   		<user-custom :showVisibles.sync='showVisibles' :rowData='rowData' @handleSuccess='handleSuccess' @closeModel='closeModel'></user-custom>
	    </transition>
	    
	    <el-dialog :visible.sync="dialogVisible">
		  <img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>		
</template>
<script>
	import draggable from 'vuedraggable'
	import userCustom from "@/components/dialog/addUserCustom"
	import { uploadUrl,imgShow } from '@/assets/js/apiConfig'
	export default {
		props:{
			showVisible: Boolean,
			dictListCode: Object,
			formData:Object,
			nowRow: Object
		},
		components: {
            draggable,
            userCustom
        },
		data(){
			return {
				urls:[],   // 图片的集合
				uploadUrl:uploadUrl,
				dialogImageUrl: '',
		        dialogVisible: false,
		        disabled: false,
				cashierdiaryDialogTitle:"添加日记账",
				dragListCopy:[],     // 拖拽数据深拷贝
				listCopy:{
					customColumnList:[],
				},     // 列表数据深拷贝
				allData:{}, //自动计算数据
				addCashierdiaryDialogLoading: false,      // loading
				nowSaveId: "",         // 当前保存id
				headerConfig:[],  //表头
				modalR: true, /// 刷新列表
				rowData: {},  // 当前点击编辑列
				disableList:[], // 禁用列表
				dragList:[],
				form:{         // 表单数据
					date:'',
          summary:'',
          id:"",
          debitMoney:'',
          creditorMoney:'',
          fkJournalAccountId:"",
          customColumnList:[]
				},
				saveNext: false,    // 保存后继续创建下一条
				rules: {
					date: [
						{ required: true, message:'开始时间不能为空！' }
					],
					summary: [
						{ required: true, message:'摘要不能为空！' }
					],
					debitMoney: [
						{ required: true, validator: this.isNumberRule}
					],
					creditorMoney: [
						{ required: true, validator: this.isNumberRule}
					]
				},
				fastChange: false,   // 是否开启快速面板
				fastChange_dis:false , // 是否禁用快速面板
				showVisibles: false,   // 是否显示添加自定义
				 items: [1,2,3,4,5,6,7,8,9],
				 options: [{
			          value: '选项1',
			          label: '黄金糕'
			        }, {
			          value: '选项2',
			          label: '双皮奶'
			        }, {
			          value: '选项3',
			          label: '蚵仔煎'
			        }, {
			          value: '选项4',
			          label: '龙须面'
			        }, {
			          value: '选项5',
			          label: '北京烤鸭'
			        }],
			        value: '',
			}
		},
		created() {
			this.getDisableList();
			this.getTableHeader();
			this.getUserCustomList();
			this.isOnbar();
		},
		mounted() {
			
		},
		deactivated() {
			this.isShow = false;
			this.showVisibles = false;
    	},

		computed: {
			// 显示弹窗
			isShow: {
				get () {
					return this.showVisible;
				},
				set (val) {
					this.$emit('update:showVisible', val);
				}
			},
			userAccount() {
				let data = JSON.parse(JSON.stringify(this.dictListCode.account));
				if(data&&data.length) {
					data.forEach((i,index)=>{
						if(!i.id) {
							data.splice(index,1);
						}
					})
				}
				return data;
			}
		},
		methods: {
			// 点击移出图片
			handleRemove(file,item) {
		        let nameStr = file.name;
		        // 给当前操作的图片赋值
		       	item.imgList.forEach((i,index)=>{
		        	if(i.name === nameStr) {
		        		item.imgList.splice(index,1)
		        	}
		        })
    			this.form.customColumnList = this.dragList;
		    },
		    // 点击查看图片
		    handlePictureCardPreview(file) {
		       this.dialogImageUrl = file.url;
		       this.dialogVisible = true;
		    },
		    // 上传成功
		    handleUploadSuccess(res, file, fileList,item) {
		    	if(res&&res.code==200) {
		    		if(res.data.length) {
		    			let arr = {
		    				name:file.name,
		    				url:imgShow + res.data[0],
		    			};
		    			// 给当前操作的图片赋值
		    			item.imgList.push(arr);
		    			this.form.customColumnList = this.dragList;
		    		}
		    	}

		    },
		    // 上传失败
		    errorUpload(err, file, fileList) {
		    	console.log(err)
		    },
		    // 上传之前验证。
		    beforeUpload(file) {
		    	 const isJPG = file.type === 'image/jpeg';
		    	 const isPNG = file.type === 'image/png';
		    	 const isLt2M = file.size / 1024 / 1024 < 10;
		    	 if(!isJPG&&!isPNG) {
		    	 	this.$message.error('只能上传图片且只能是 JPG 格式或者 PNG 格式！');
		    	 }
		    	 if(!isLt2M) {
		    	 	 this.$message.error('上传图片大小不能超过 10MB!');
		    	 }
		    	 return (isJPG || isPNG) && isLt2M
		    },
			closeModel(data) {
				if(data) {
					let _ = this;
					
					setTimeout(()=>{
						_.$router.push({
							path:'./companyAttributes'
						})
					},0)
					
				}
			},
			// enter时间到了
			keyUpEnterDown(type,i) {
				if(type === "date") {
					this.$refs.summaryDom.focus()
				}else if(type === "summary") {
					if(this.form.summary) {
						this.$refs.debitMoneyDom.focus()
					}
				}else if(type === "debitMoney") {
					this.$refs.creditorMoneyDom.focus()
				}else if(type === "creditorMoney") {
					if(!this.form.debitMoney&&!this.form.creditorMoney) {
						this.$refs.debitMoneyDom.focus()
					}else {
						// 自定义列表enter时间到哦了
						this.$refs[`${this.dragList[0].enterTime}`][0].focus()
					}
					
				}else {
					// 自定义列表enter时间到哦了
					if(i.isStuff === 1) {
						if(i.value || i.optionListValue.length) {
							let row = this.dragList.find((i,index)=>{return index===type+1})
							this.$refs[`${row.enterTime}`][0].focus()
						}
					}else {
						if(i.customType==="4") return;
						let row = this.dragList.find((i,index)=>{return index===type+1})
						if(row) {
							this.$refs[`${row.enterTime}`][0].focus()
						}
					}
				}
			},
			// input框获取焦点全选
			hanleInputFocus(e) {
				e.target.select()
			},
			// 账户切换
			handleSelectChange(val) {
				this.$emit('handleSelectChangeId',val)
			},
			// 收入支出清空
			clearOther(type) {
				if(type==="1"&&this.form.debitMoney!="") {
					this.form.creditorMoney = "";
				}else if(this.form.creditorMoney){
					this.form.debitMoney="";
				}
			},
			// 收入支出失去焦点
			isInputBlur(type) {
				// if(type === "debitMoney") {
				// 	if(this.form.debitMoney!=="") {
				// 		this.form.creditorMoney = "";
				// 	}
				// }else if(type === "creditorMoney") {
				// 	if(this.form.creditorMoney!=="") {
				// 		this.form.debitMoney = "";
				// 	}
				// }else {

				// }
				this.form.customColumnList = this.dragList;
				this.listCopy = JSON.parse(JSON.stringify(this.form))
				
			},
			// 列表下拉框和日期改变保存当前表格
			handleDateChange(val) {
				this.form.customColumnList = this.dragList;
				this.listCopy = JSON.parse(JSON.stringify(this.form))
			},
			makeAllData(){
			    this.allData.debitMoney=Number(this.form.debitMoney)
			    this.allData.creditorMoney=Number(this.form.creditorMoney)
			    this.dragList.forEach(i=>{
			     var k="field_"+i.id;
			     this.allData[k]=i.value==null?0:Number(i.value)
			    })
			   },
		   calculation(data){
		    this.makeAllData();
		    if(data.valueType=='1'){
		    	 data.value=eval(data.formula)?eval(data.formula):0;
		    }
		    return data.value;
		   },
			// 保存快速开启
			saveFastBar(val){
				this.$http.post('custom/updatePanelState' , {type:val}).then(res=>{
					if(res&&res.data.code==1) {
						
					}
				})
			},
			// 获取是否开启面板
			isOnbar(){
				this.$http.post('custom/getPanelState' , {}).then(res=>{
					if(res&&res.data.code==1) {

						this.fastChange = res.data.data;
					}
				})
			},
			// 上一张，下一张
			handleClickJump(type) {
				
				let parms = {
					journalPeriodId:this.nowSaveId,
					type: type
				}
				this.addCashierdiaryDialogLoading = true;
				this.$http.post('journal/cutJournalPeriod' , parms).then(res=>{
					this.addCashierdiaryDialogLoading = false;
					if(res&&res.data.code==1) {
						let list = res.data.data;
						this.nowSaveId = list.id;
						this.form = Object.assign(this.form,{
			          		date:list.date,
			          		debitMoney:list.debitMoney,
			          		summary:list.summary,
			          		creditorMoney:list.creditorMoney,
			          		customColumnList:list.customColumnList,
			          		id:list.id
			          	})
			          	for(var k=0;k<list.customColumnList.length;k++) {
			          		for(var i=0;i<this.dragList.length;i++) {
			          			if(this.dragList[i].id===list.customColumnList[k].id) {
			          				this.dragList[i].value=list.customColumnList[k].value;
				          			this.dragList[i].optionListValue=list.customColumnList[k].optionListValue;
				          			this.dragList[i].imgList=list.customColumnList[k].imgList;
			          			}
				          		
					         }
			          	}
			          	
					}
				})
			},
			// 保存数据
			handleSaveRow() {
				this.$refs.modalData.validate((valid)=>{
					if(valid) {
						
						let autoC = this.dragList.find(i=>{return i.customType==="3"&&i.valueType===1&&i.value===Infinity});
						if(autoC&&autoC.value===Infinity) {
							return this.$message.warning(`检测到公式"${autoC.columnName}"中有除数为零，请检查后再保存！`)
						}
						this.form.date = this.$util.formatDate.format(this.form.date , 'yyyy-MM-dd');

						let isImg = this.form.customColumnList.find(item=>{return item.isStuff==1&&item.customType==5&&!item.imgList.length})
						if(isImg) {
							return this.$message.warning('缺少上传图片')
						} 
						this.addCashierdiaryDialogLoading = true;
						this.$http.post('journal/saveJournalPeriod' , this.form).then(res=>{
							this.addCashierdiaryDialogLoading = false;
							if(res&&res.data.code==1) {
								
								this.nowSaveId = res.data.data;
								this.$message.success("保存成功!")
								if(this.saveNext) {
									this.clearList(); 
									this.dragList = JSON.parse(JSON.stringify(this.dragListCopy));
								}else {
									this.isShow=false;
								}
								this.$emit('successSaveHightLight',this.$util.formatDate.format(this.form.date , 'yyyyMM'))
							}
						})
					}
				})
				
			},
			// 子组件保存成功返回
			handleSuccess(data) {
				if(data==="0") {
					this.getTableHeader();
				}else if(data==="1") {
					this.getUserCustomList();
				}
				this.$emit("successSave",true);
			},
			 // 查询表头
		      getTableHeader(){
		        this.$http.post('journal/findJournalPeriodTitle' , {}).then(res=>{
		            if(res&&res.data.code == 1) {
		            	this.headerConfig=[];
		               if(res.data.data.length) {
		               		res.data.data.forEach(i=>{
		               			if(i.customType === "1") {   // 文本
		               				this.headerConfig.push({
		               					sortable: false,          // 是否可以排序 
		               					 width:"150px",
							              label: i.columnName,
							              value: i.value,
							              valueType:i.valueType,
							              type: 'text',
							              id: i.id,
							              decimalNum:i.decimalNum,
							              isTotal:i.isTotal,
							              fixed: "",
							              function: this.filtersTextMethod,
							              filters:[{data:""}],
							              render: {name: "input" , autoselect:true}
		               				})
		               			}else if(i.customType === "2"){  // 日期
		               				this.headerConfig.push({
		               					sortable: true,          // 是否可以排序 
		               					width:"150px",
							              label: i.columnName,
							               valueType:i.valueType,
							              value: i.value,
							              type: 'date',
							              id: i.id,
							              decimalNum:i.decimalNum,
							              isTotal:i.isTotal,
							              fixed: "",
							                function: this.filtersDateMethod,
							                filters:[{data: ''},{data: ''}],
							                render: {name: "input" , autoselect:true}
		               				})

		               			}else if(i.customType === "3"){   //数值
		               				this.headerConfig.push({
		               					sortable: i.id!=="5"?true:false,          // 是否可以排序 
		               					width:"150px",
							              label: i.columnName,
							              value: i.value,
							              id: i.id,
							              label:i.unit?i.columnName+"("+i.unit+")":i.columnName,
							               valueType:i.valueType,
							              decimalNum:i.decimalNum,
							              isTotal:i.isTotal,
							              type: 'number',
							              fixed: "",
							              function: this.filtersNumberMethod,
							               filters:[{data: ''},{data: ''}],
							                render: {name: "input" , autoselect:true}
		               				})

		               			}else if(i.customType === "4" && i.isChoice===0){  //单选
		               				this.headerConfig.push({
		               					sortable: false,          // 是否可以排序 
		               					width:"150px",
							              label: i.columnName,
							              id: i.id,
							               valueType:i.valueType,
							              decimalNum:i.decimalNum,
							              value: i.value,
							              isTotal:i.isTotal,
							              fixed: "",
							              optionList: i.optionList,
							              type: 'select_s',
							              function: this.filtersSelect_sMethod,
							               filters:[{data:""}],
							                render: {name: "input" , autoselect:true}
		               				})
		               			}else if(i.customType === "5"){  // 图片
		               				this.headerConfig.push({
		               					sortable: false,          // 是否可以排序 
		               					width:"150px",
							              label: i.columnName,
							              id: i.id,
							              valueType:i.valueType,
							              decimalNum:i.decimalNum,
							              value: i.value,
							              isTotal:i.isTotal,
							              fixed: "",
							              imgList: i.imgList,
							              type: 'img',
							              function: null,
							               filters:null,
							             render: {}
		               				})
		               			}else{  // 多选
		               				this.headerConfig.push({
		               					sortable: false,          // 是否可以排序 
		               					width:"150px",
							              label: i.columnName,
							              value: i.value,
							               valueType:i.valueType,
							              id: i.id,
							              decimalNum:i.decimalNum,
							              fixed: "",
							              isTotal:i.isTotal,
							               optionList: i.optionList,
							              type: 'select_d',
							              function: this.filtersSelect_dMethod,
							               filters:[{data:""}],
							                render: {name: "input" , autoselect:true}
		               				})
		               			}
		               		})
		               }
		               this.$emit('configHeader',this.headerConfig)
		            }
		          })
		      },
		      // 数值搜索
		      filtersNumberMethod ({option, row,column}) {
		      		if(row.isBeginning===1){return true};
		      		// if(isNaN(column.filters[0].data)||isNaN(column.filters[1].data)) {
		      		// 	return this.$message.warning('检索条件只能是数值！')
		      		// }
			      	if(typeof(row[column.property])==="object") {
			      		if(column.filters[0].data==="") {
			      			return row[column.property].value <=Number(column.filters[1].data);
			      		}
			      		if(column.filters[1].data==="") {
			      			return row[column.property].value >=Number(column.filters[0].data);
			      		}
			      		 return  Number(column.filters[0].data)<= row[column.property].value &&  row[column.property].value <=Number(column.filters[1].data)
			      		
			      	}else {
			      		if(column.filters[0].data==="") {
			      			return row[column.property] <=Number(column.filters[1].data);
			      		}
			      		if(column.filters[1].data==="") {
			      			return row[column.property] >=Number(column.filters[0].data);
			      		}
			      		 return  Number(column.filters[0].data)<= row[column.property] &&  row[column.property] <=Number(column.filters[1].data)
			      	}
		         
		        },
		        // 单选搜索
		        filtersSelect_sMethod({option, row,column}) {
		        	if(row.isBeginning===1){return true};
		        		return column.filters[0].data.find(i=>{return i===row[column.property].id})
		        },
		        // 多选搜索
		        filtersSelect_dMethod({option, row,column}) {
		        	if(row.isBeginning===1){return true};
		           if(option.data) {
		            let dataS = option.data;
		            if(row[column.property].id!==null) {
		             let rowID = row[column.property].id.toString();
			       for(let k=0;k<dataS.length;k++){
			        let regTest = dataS[k];
			        if(rowID.indexOf(regTest) != -1){
			         return true;
			        }
		       	}
		            }
		           }
		           return false
          		},
		        // 日期搜索
		        filtersDateMethod({option, row,column}){
		        	if(row.isBeginning===1){return true};
		        	if(column.filters[0].data&&!column.filters[1].data) {
		      			column.filters[1].data = column.filters[0].data;
		      		}
		          let start = this.$util.formatDate.format(column.filters[0].data , 'yyyy-MM-dd');
		          let end = this.$util.formatDate.format(column.filters[1].data , 'yyyy-MM-dd');
		          if(typeof(row[column.property])==="object") {				
		          	let value = row[column.property].value;
		          	return start <= value && value<=end
		          }else {
		          	return start <= row[column.property] && row[column.property]<=end
		          }
		        },
		        // 文本搜索
		        filtersTextMethod({option, row,column,type}){
		        	if(row.isBeginning===1){return true};
		           if(option.data===""){
		              return false;
		           }
		           if(typeof(row[column.property])==="object") {
		           		if(row[column.property].value !==""){
		           			if(option.isAccurate) {  // 精确筛选
		           				return row[column.property].value.toLowerCase() === option.data.toLowerCase();
		           			}else {  // 模糊筛选
		           				return (row[column.property].value.toLowerCase()).indexOf(option.data.toLowerCase())>=0;
		           			}
			              
			           }else {
			            return false;
			           }
		           }else {
		           		if(row[column.property] !==""){
		           			if(option.isAccurate) {  // 精确筛选
		           				return row[column.property].toLowerCase() === option.data.toLowerCase();
		           			}else {  // 模糊筛选
		           				 return (row[column.property].toLowerCase()).indexOf(option.data.toLowerCase())>=0;
		           			}
			           }else {
			            return false;
			           }
		           }
		           
		        },
			// 点击打开自定义列弹框
			addShow(){
				this.nowRow.superMarket = false;
				this.rowData = {};
				this.showVisibles = true;
			},
			// 编辑固定列
			handleEditItems(id) {
				let row = {
					columnName:"",
					customType:'',
					decimalNum:"",
					decimalNum_s:"",
					id:id,
					isChoice:0,
					isStuff:1,
					isTotal:0,
					numValue:'',
					value:"",
					valueType:0,
					optionList:[],
					optionListValue:[],
					isControl:"",
					rule:"",
					controlType:"",
				}
				if(id==="1") {
					row.columnName = "日期"
					row.customType = "2"
				}else if(id==="2") {
					row.columnName = "摘要"
					row.customType = "1"
				}else if(id==="3"){
					row.columnName = "收入"
					row.customType = "3"
				}else {
					row.columnName = "支出"
					row.customType = "3"
				}
				this.rowData = row;
				this.showVisibles = true;
			},
			// 编辑
			handleEditItem(type,row,status) {
				//return
				if(type==='delete') {
					this.$http.post('custom/deleteCustomAndOption' , {id:row.id, type: "1"}).then(res=>{
						if(res&&res.data.code == 1) {
							if(res.data.data) {
								this.$prompt('该项已被使用，删除后所有明细都不再显示该列且不可恢复，请谨慎操作！', '提示', {
							          confirmButtonText: '确定',
							          cancelButtonText: '取消',
							          inputPlaceholder: "输入DELETE删除",
							          inputPattern: /[dD][eE][lL][eE][tT][eE]/,
          							  inputErrorMessage: '请输入DELETE,不区分大小写'
							        }).then(({value}) => {
						        		this.$http.post('custom/deleteCustomColumn' , {id:row.id}).then(res=>{
											if(res&&res.data.code == 1) {
												this.getUserCustomList();
												this.getDisableList();
												if(status==="nor") {
													this.getTableHeader();
												}
												this.$message({
										            type: 'success',
										            message: res.data.msg
										          });
											}
										})
							        }).catch(() => {
							                  
							        });
							}else {
								this.$confirm('此操作将删除该自定义列, 数据将不可恢复，是否继续?', '提示', {
							          confirmButtonText: '确定',
							          cancelButtonText: '取消',
							          type: 'warning'
							        }).then(() => {
							        	this.$http.post('custom/deleteCustomColumn' , {id:row.id}).then(res=>{
											if(res&&res.data.code == 1) {
												this.getUserCustomList();
												this.getDisableList();
												if(status==="nor") {
													this.getTableHeader();
												}
												this.$message({
										            type: 'success',
										            message: res.data.msg
										          });
											}
										})
							          
							        }).catch(() => {
							                  
							        });
							}
						}
					})
				}else if(type==="disable") {
					let hit = status==="1"?"此操作将禁用该自定义列,是否继续?":"是否取消禁用？"
					this.$confirm(hit, '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          type: 'warning'
				        }).then(() => {
				        	this.$http.post('custom/bandCustomColumn' , {customColumnId:row.id,type:status}).then(res=>{
								if(res&&res.data.code == 1) {
									this.getUserCustomList();
									this.getDisableList();
									this.getTableHeader();
									if(status === "2") {
										this.$emit('successSave',true);
									}
									this.$message({
							            type: 'success',
							            message: res.data.msg
							          });
								}
							})
				          
				        }).catch(() => {
				                  
				        });
				}else if(type==="modify") {
					if(status ==='common') {
						this.rowData = row;
						this.showVisibles = true;
					}
				}
			},
			// 获取自定义列表
			getUserCustomList(){
				let _ = this;
				_.$http.post('custom/findCustomColumn' , {}).then(res=>{
					if(res&&res.data.code == 1) {
						_.dragList = res.data.data.map((i,index)=>{
							if(i.isStuff) {
								i.verification = "value_"+i.id;
								_.rules[i.verification] = [
									{ required: true, validator: _.isexChangerate }
								]
							}
							i.enterTime = "value"+i.id;
							// 自动计算
							// if(i.customType==="3") {
							// 	if(i.valueType===1) {
							// 	}
							// }
							return i;
						});
						_.dragListCopy= JSON.parse(JSON.stringify(_.dragList))
						if(_.dragList.length){
							this.fastChange_dis = true;
							if(this.fastChange) {
								this.saveFastBar(false);
							}
							this.fastChange = false;
							
						}else {
							this.fastChange_dis = false;
						}
						if(this.nowRow.id) {
							this.cashierdiaryDialogTitle = "修改日记账";
							this.getListData();
						}else if(!this.nowRow.superMarket) {
							this.cashierdiaryDialogTitle = "新增日记账";
							this.getListData_plus();
						}else {
							this.cashierdiaryDialogTitle = "新增日记账";
						}
						_.modalR = false;
						_.$nextTick(()=>{
							_.modalR = true;
							this.makeAllData();
						})
					}
				})
			},
			// 收入支出验证
			isNumberRule(rule,value,callback) {
				
				if(value&&!Number(value)&&Number(value)!==0) {
					return callback( new Error(`当前选项只能是数字！`) )
				}else {
					return callback();
				}
			},
			// 自定义验证
			isexChangerate(rule,value,callback){
				this.dragList.forEach(i=>{
					if(i.verification === rule.field) {
						if(i.customType!=="5"&&!(i.optionListValue.length!==0) && !i.value) {
							return callback( new Error(`${i.columnName} 不能为空！`) )
						}else {
							if(i.customType==="3") {
								if(!Number(i.value)) {
									return callback( new Error(`${i.columnName} 只能是数字！`) )
								}else {
									return callback();
								}
							}else {
								return callback();
							}
						}
					}
				})
			},
			// 获取禁用列表
			getDisableList(){
				this.$http.post('custom/getBandCustomColumn' , {}).then(res=>{
					if(res&&res.data.code == 1) {
						this.disableList = res.data.data;
					}
				})
			},
			// 拖动开始
			handleStart(e){
				e.item.style.background='#eee';
				e.item.style.transform='scale(1.1)';
				e.item.style.borderRadius ='5px';
				e.item.style.opacity ='.5';
				e.item.style.paddingLeft ='10px';
			},
			// 拖动结束
			handleEnd(e) {
				e.item.style.background='';
				e.item.style.transform='scale(1)';
				e.item.style.borderRadius ='0px';
				e.item.style.opacity ='1';
				e.item.style.paddingLeft ='0px';
				this.$http.post('custom/sortCustom' , {columnList:this.dragList}).then(res=>{
					if(res&&res.data.code == 1) {
						this.getTableHeader();
						//this.$emit('successSave',true)
						this.$message.success(res.data.msg)
					}
				})

			},
			// 清空列表方法
			clearList(){
				this.form = Object.assign(this.form,{
	          		debitMoney:"",
	          		summary:"",
	          		creditorMoney:"",
	          		customColumnList:[],
	          		id:""
	          	})
	          // 	for(var i=0;i<this.dragList.length;i++) {

	          // 		this.dragList[i].value="";
	          // 		this.dragList[i].optionListValue=[];
		         // }
		          this.$nextTick(()=>{
						this.$refs.modalData.clearValidate();
					})
			},
			// 修改列表赋值方法
			getListData() {
				let da=[];
					this.nowSaveId = this.nowRow.id;
			          for(var i in this.nowRow) {
			           let is= i.split("-");
			              if(is[0] === 'value'){
			                let obj=new Object();
			                 obj.id= is[1];
			                if(this.nowRow[i]&&this.nowRow[i].id){
			                  if(typeof(this.nowRow[i].id) === "string"){
			                      obj.value=this.nowRow[i].id
			                  }else {
			                      obj.optionListValue=this.nowRow[i].id
			                  }
			                }else if(this.nowRow[i].customType==5){
			                  obj.imgList = this.nowRow[i].imgList?this.nowRow[i].imgList:[]
			                }else{
			                  obj.value=this.nowRow[i].value;
			                }
			                obj.customType = this.nowRow[i].customType;
			                 da.push(obj)
			              }
			          }
			          this.nowRow.customColumnList=da;
			          this.form = Object.assign(this.form,{
			          		date:this.nowRow.date,
			          		debitMoney:this.nowRow.debitMoney,
			          		summary:this.nowRow.summary,
			          		creditorMoney:this.nowRow.creditorMoney,
			          		customColumnList:this.nowRow.customColumnList,
			          		id:this.nowRow.id
			          })
			          for(var i=0;i<this.dragList.length;i++) {
			          	for(var k=0;k<this.nowRow.customColumnList.length;k++) {
			          		if(this.dragList[i].id===this.nowRow.customColumnList[k].id) {
			          			if(this.nowRow.customColumnList[k].optionListValue) {
			          				this.dragList[i].optionListValue = this.nowRow.customColumnList[k].optionListValue;
			          			}else if(this.nowRow.customColumnList[k].imgList){
			          				this.dragList[i].imgList = this.nowRow.customColumnList[k].imgList;
			          			}else{
			          				this.dragList[i].value = this.nowRow.customColumnList[k].value;
			          			}
			          		}
			          	}
			          }
			},
			// 新增列表赋值方法
			getListData_plus(){
				 this.form = Object.assign(this.form,{
	          		debitMoney:this.listCopy.debitMoney,
	          		summary:this.listCopy.summary,
	          		creditorMoney:this.listCopy.creditorMoney,
	          		customColumnList:this.listCopy.customColumnList,
	          		id:""
	            })
				  for(var i=0;i<this.dragList.length;i++) {
				  		for(var k=0;k<this.listCopy.customColumnList.length;k++) {
				  			if(this.dragList[i].id===this.listCopy.customColumnList[k].id) {
			          			this.dragList[i].value = this.listCopy.customColumnList[k].value;
			          			this.dragList[i].optionListValue = this.listCopy.customColumnList[k].optionListValue;
			          		}
				  		}
				  }
			}


		},
		watch:{
			showVisibles(val) {
				if(val) {
					this.isShow = false;
				}else {
					
					this.isShow = true;
				}
			},
			isShow(val) {
				if(val) {

					this.$nextTick(()=>{
						this.$refs.modalData.clearValidate();
					})
					//this.form.date = this.formData.endYearPeriods.slice(0,4)+"-"+this.formData.endYearPeriods.slice(4);
					console.log(this.formData.fkJournalAccountId)
					this.form.date = this.$util.formatDate.format(new Date , 'yyyy-MM-dd');
					this.form.fkJournalAccountId = this.formData.fkJournalAccountId;
					
					this.getUserCustomList();
					
				}else {
					this.nowSaveId = "";
					this.clearList();
				}
			},
			fastChange(val) {
				let _ = this;
					_.addCashierdiaryDialogLoading = true;
					setTimeout(()=>{
						if(val) {
							this.$emit("fastChangeMsg",true);
						}else {
							this.$emit("fastChangeMsg",false);
						}
						_.addCashierdiaryDialogLoading = false;
					},1000)
				
				this.saveFastBar(val);
			}
			
		}
	}
</script>
<style lang="less">
/**/

.dotColor {
			width: 10px;
			height: 10px;
			border-radius: 50%;
			position: absolute;
			z-index: 9999;
			top: 13px;
			left: 8px;
		}
	.active_fade-enter,.active_fade-leave-to{
		 opacity: 0;
         transform: rotateY(90deg);
	}
	.active_fade-enter-active,.active_fade-leave-active{
		 transition: all .2s linear;
	}
	.el-popover {
		/*background: rgba(64,64,64,0.85);
		border:none;
		.popper__arrow {
			&::after{
				border-bottom-color: rgba(64,64,64,0.85) !important;
				top:0 !important;
			}
		}*/
		.edit {
			color: #268AFF;
			display: inline-block;
			text-align: center;
			width: 100%;
			cursor: pointer;
			&:hover {
				color: #268AFF;
				opacity: .6;
			};
		}
		.cancel {
			color: #F5A623;
			display: inline-block;
			text-align: center;
			width: 100%;
			padding: 15px 0;
			cursor: pointer;
			&:hover {
				color: #F5A623;
				opacity: .6;
			};
		}
		.delete {
			color: #DB374B;
			display: inline-block;
			text-align: center;
			width: 100%;
			cursor: pointer;
			&:hover {
				color: #DB374B;
				opacity: .6;
			};
		}
	}
	#addCashierdiaryDialog {

		/*图片上传*/
		.picUpload {
			.el-upload--picture-card {
				width: 80px;
				height: 80px;
				line-height: 80px;
				.el-icon-plus {

				}
			}
			.el-upload-list--picture-card .el-upload-list__item {
				width: 80px;
				height: 80px;
			}
		}

		/*end*/
		.el-dialog__body {
			padding: 0 30px 30px;
		}

		.el-dialog__header{
			padding: 40px 30px;
			text-align:center;
			border-bottom: none;
			.el-dialog__title {
				font-size: 30px;
				color: #333;
				font-weight:500;
			}
		}
		.add_title {
			
			.addHeader {
			  	padding:0px 0px 25px;
			  	.fast_change {
					font-size: #4A4A4A !important;

				}
				.setForm {
					line-height: 40px;
					color: #666;
					font-size: 14px;
					cursor: pointer;
				}
			  }
			
		}
		 
		
		 .list-item {
		    display: block;
		    margin-right: 10px;
		    background-color: orange;
		    width: 30px;
		    height: 30px;
		    margin: 20px 0;
		    line-height: 30px;
		    text-align: center;
		    color: #ffffff;
		  }
		 
		  /*** 元素定位改变时动画 ***/
		  .list-move {
		    transition: transform .5s;
		  }
		 
		  .addContent {
		  	.addContent_container {
		  		padding: 0 30px;
		  		border:1px solid rgba(238,238,238,1);
		  		.el-form-item {
		  			margin-bottom: 0px;
		  			border-bottom: 1px dashed #eee;
		  			padding: 12px 0px;
		  			display: flex;
		  			align-items: center;
		  			.el-form-item__content{
		  				margin-left: 30px !important;
		  				line-height: 40px !important;
		  				flex:1;
		  				.more {
			  				font-size: 20px;
			  				cursor: pointer;
			  			}
			  			.move_able {
			  				cursor: move !important;
			  			}
		  			}
		  			.el-form-item__label {
		  				border-right:1px solid #eee;
		  				padding: 0 16px 0 0; 
		  				color: #333;
		  				font-size: 14px;
		  				font-weight: bold;
		  				position: relative;
		  				&::before{
		  					position:absolute;
		  					left: -10px;
		  				};
		  			}
		  			.el-input__prefix {
		  				left: 200px;
		  			}
		  			/*.el-input__icon{
		  				text-align: right;
		  			}*/

		  		}

		  	}
		  }
		  .disabled_item {
		  	padding: 40px 0px;
		  	.disable_on {
		  		color: #333333;
		  		font-weight: bold;
		  	}
		  	.disable_items {
		  		margin-top: 15px;
		  		.item {
		  			display: inline-block;
            height:22px;
            background:rgba(247,247,247,1);
            border-radius:4px;
            color: #999;
            border:1px solid rgba(233,233,233,1);
            padding: 2px 8px;
            box-sizing: border-box;
            font-size: 12px;
            margin: 0 10px 10px 0;
					i {
						margin-left: 5px;
					}
		  		}
		  	}
		  }
		  .footer {
		  	margin-top: 40px;
		  	text-align: center;
		  	.saveNext_container {
		  		margin-bottom: 33px;
		  		.saveNext {
		  			color: #4A4A4A;
		  		}
		  	}
		  	.nextOrBack {
		  		display:flex;
		  		justify-content: space-between;
		  		.back {
		  			font-size: 16px;
		  			font-weight: bold;
		  		}
		  	}
		  	
		  }

	  	.cancel_btn {
	  		width: 122px;
	  		background: #9B9B9B;
	  		color: #FFFFFF;
	  	}
	  	.save_btn{
	  		width: 122px;
	  		background: #408BFF;
	  		color: #FFFFFF;
	  	}
	}
	
</style>


// WEBPACK FOOTER //
// src/components/dialog/addCashierdiaryDialog.vue